export const GRANT_STATUS = [
    {label: 'Monthly', _id: '508f1f77bcf86cd799449022'},
    {label: 'Quarterly', _id: '508f1f77bcf86cd799439022'},
    {label: 'Semi-annual', _id: '508f1f77bcf86cd799439023'},
    {label: 'Annual', _id: '508f1f77bcf86cd799439024'},
].map(d => ({...d, active: true}));
